import { fetchPhpEigth } from 'api';
import useCustomToast from 'hooks/useCustomToasts';
import { useHistory } from 'react-router';
import { CASUALITY_GENERAL } from '../constantes';

const useSuscriptorFunctions = () => {
    const { addWarningToast } = useCustomToast();

    const validate = async (resumen, infoUsuario) => {
        const pasoActual = resumen?.pasoActual ?? '';
        const infoAsesor = resumen?.carrito?.carAsesor ?? {};
        const respValidate = {
            redirect: false,
            link: null
        };
        if (infoUsuario.isSuscriptor) {debugger
            if (infoAsesor?.idSuscriptor) {
                if (infoAsesor?.idSuscriptor !== infoUsuario.cliCodigoCore) {
                    addWarningToast(resumen?.msgErroresSuscriptor?.msgErrorSuscriptorNoLogueado);
                    respValidate.redirect = true;
                    respValidate.link = `/login?user=clientes`;
                }
            } else {
                if (CASUALITY_GENERAL.suscriptorAccess[`${pasoActual}`]) {
                    try {
                        const Body = {
                            idSuscriptor: infoUsuario.cliCodigoCore,
                            idCotizacion: resumen?.carrito?._id,
                            paso: "tomarSuscriptor"
                        }
                        const responseSave = await fetchPhpEigth(CASUALITY_GENERAL.endpoints.asignacionSuscriptor, Body);
                        if (!responseSave?.transaccion) {
                            addWarningToast('Ha ocurrido un problema al recuperar la cotización');
                            respValidate.redirect = true;
                            respValidate.link = `/`;
                        }
                    } catch (error) { }
                }
            }debugger
            if (CASUALITY_GENERAL.suscriptorAccess[`${pasoActual}`] && infoAsesor?.finalizoFlujoSucriptor) {
                addWarningToast(resumen?.msgErroresSuscriptor?.msgErrorSuscriptorFinalizoFlujo);
            }
            if (!CASUALITY_GENERAL.suscriptorAccess[`${pasoActual}`]) {
                addWarningToast('Su usuario no posee permisos para ingresar a esta página');
                respValidate.redirect = true;
                respValidate.link = `/`;
            }
        }
        debugger
        if (infoUsuario.isAgente) {
            if (infoAsesor?.idSuscriptor && !infoAsesor?.finalizoFlujoSucriptor) {
                addWarningToast(resumen?.msgErroresSuscriptor?.msgErrorAgenteRecuperacion);
                respValidate.redirect = true;
                respValidate.link = `/`;
            }
        }
        return respValidate;
    }
    return {
        validate
    };
};

export default useSuscriptorFunctions;
